<template>
  <v-footer
    id="core-footer"
    absolute
    height="82"
  >
    <div class="footer-items">
      <span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          class="tertiary--text footer-links">{{ link.name }}</a>
      </span>
    </div>
    <v-spacer/>
    <span class="font-weight-light copyright">
      &copy;
      1995 - {{ datesite }}
      <a
        href="https://www.thecompagnie.eu/"
        target="_blank">Thecompagnie</a>, made with
      <v-icon
        color="tertiary"
        size="17">mdi-heart</v-icon>
      for Newmat
    </span>
  </v-footer>
</template>

<script>
import { moment } from '@/plugins/moment'

export default {
  data: () => ({
    test: '',
    test1: '',
    test2: '',
    links: [
      { name: 'Un bug?', Link: 'mailto:kdorion@thecompagnie.eu' }
    ]
  }),
  computed: {
    datesite () {
      return moment(new Date()).format('YYYY')
    }
  }
}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
